import { render, staticRenderFns } from "./inputfile.vue?vue&type=template&id=7f3d5b5c&"
import script from "./inputfile.js?vue&type=script&lang=js&"
export * from "./inputfile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f3d5b5c')) {
      api.createRecord('7f3d5b5c', component.options)
    } else {
      api.reload('7f3d5b5c', component.options)
    }
    module.hot.accept("./inputfile.vue?vue&type=template&id=7f3d5b5c&", function () {
      api.rerender('7f3d5b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/inputs/inputfile.vue"
export default component.exports